/* ROTEM+ product forms — variant selection + AJAX add to cart */
(function () {
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[action$="/cart/add"], form[data-product-form-quick]');
    if (!form || !window.rotemCart) return;
    event.preventDefault();
    window.rotemCart.add(new FormData(form), form.querySelector('[data-add-to-cart]'));
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-option-index]');
    if (!input) return;

    const form = input.closest('form');
    const select = form.querySelector('[data-variant-select]');
    if (!select) return;

    const chosen = Array.from(form.querySelectorAll('[data-option-index]:checked')).map(
      (el) => el.value
    );

    form.querySelectorAll('.chip-toggle').forEach((label) => {
      const radio = label.querySelector('input');
      label.classList.toggle('is-active', !!radio && radio.checked);
    });

    const match = Array.from(select.options).find(
      (option) => option.getAttribute('data-options') === chosen.join(' / ')
    );

    const button = form.querySelector('[data-add-to-cart]');
    if (match) {
      select.value = match.value;
      if (button) {
        button.disabled = match.disabled;
        button.textContent = match.disabled
          ? window.rotemStrings.unavailable
          : window.rotemStrings.addToCart;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.value);
      window.history.replaceState({}, '', url);
    } else if (button) {
      button.disabled = true;
      button.textContent = window.rotemStrings.unavailable;
    }
  });
})();
